import { combineReducers } from "redux";
import accounts from "./accounts";
import procedure from "./procedure";

export default combineReducers({
  accounts,
  procedure,
});
